<aside class="right-panel" [class.open]="isOpen">
	<div class="right-panel-header" style="margin-top: 60px;">
		<div class="right-panel-title">
			<div class="signal-r"  style="display: inline-block; margin-right: 10px; cursor: pointer;">
				<span class="fa fa-circle" [ngClass]="signalRStatus ? 'green' : 'red'"
					[matTooltip]="(signalRStatus ? 'rightPanel.signalRStart' : 'rightPanel.signalRStop') | translate">
				</span>
			</div>
			<div style="display: inline-block;">Painel</div>
		</div>
		<button mat-icon-button (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div class="right-panel-content">
		<!-- Conteúdo futuro -->
		<div class="row">
			<div class="col-12">
				<h4 class="title">
					{{ 'rightPanel.titulos.limitesConta' | translate }}
				</h4>
			</div>
		</div>
		<div class="limits mb25">
			<div class="row" *ngFor="let item of limitesContaItens">
				<div class="col-4">
					{{ 'rightPanel.limitesConta.' + item | translate }}
				</div>
				<div class="col-6" style="padding: 8px 0 0 0;">
					<div class="progress animated-progress progress-sm" style=" height: 8px;"
						[matTooltip]="limiteContaTooltip(item)">
						<div role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"
							class="progress-bar" [ngClass]="{'bg-success': limitesConta[item].porcentagem > 0 && limitesConta[item].porcentagem <= 33.33, 
							                                 'bg-warning': limitesConta[item].porcentagem > 33.33 && limitesConta[item].porcentagem <= 66.66,
															 'bg-danger': limitesConta[item].porcentagem > 66.66 }"
							[ngStyle]="{'width': limitesConta[item].porcentagem + '%'}"></div>
					</div>
				</div>
				<div class="col-2 t-right">
					<span style="font-size: 26px; height: 24px; display: block; overflow: hidden;"
						*ngIf="!limitesConta[item].possuiLimite">
						&infin;
					</span>
					<span *ngIf="limitesConta[item].possuiLimite">
						{{limitesConta[item].limite}}
					</span>
				</div>
			</div>
		</div>
		<!--
		<div class="row">
			<div class="col-12">
				<h4 class="title">
					{{ 'rightPanel.titulos.limitesProvedores' | translate }}
				</h4>
			</div>
		</div>
		<div class="limits mb25">
			<div class="row" *ngFor="let item of limitesProvedoresItens">
				<div class="col-4 ellipsis pointer" [matTooltip]="item">
					{{item}}
				</div>
				<div class="col-6" style="padding: 8px 0 0 0;">
					<div class="progress animated-progress progress-sm" style=" height: 8px;">
						<div role="progressbar" aria-valuenow="50.16" aria-valuemin="0" aria-valuemax="100"
							class="progress-bar bg-success" style="width: 90.16%;"></div>
					</div>
				</div>
				<div class="col-2">
					100
				</div>
			</div>
		</div>
		-->
		<div class="row">
			<div class="col-12">
				<h4 class="title">
					{{ 'telaCapturaTela.secaoRightPanel' | translate }}
				</h4>
			</div>
		</div>
		<div class="row mb25">
			<div class="col-12">
				<button mat-stroked-button class="btn-captura"
						[matTooltip]="'telaCapturaTela.menuSelecionarArea' | translate"
						(click)="capturarAreaSelecionada()">
					<mat-icon>crop</mat-icon>
					{{ 'telaCapturaTela.menuSelecionarArea' | translate }}
				</button>
				<button mat-stroked-button class="btn-captura"
						[matTooltip]="'telaCapturaTela.menuPaginaInteira' | translate"
						(click)="capturarPaginaInteira()">
					<mat-icon>fullscreen</mat-icon>
					{{ 'telaCapturaTela.menuPaginaInteira' | translate }}
				</button>
			</div>
		</div>
		<div class="row totalizadores">
			<div class="col-12" style="font-size: 18px; font-weight: bold;">
				{{ totalIndexado | numberFormat: 0 }}
			</div>
			<div class="col-12">
				{{ 'rightPanel.titulos.registrosIndexados' | translate }}
			</div>
		</div>
		<div class="row totalizadores">
			<div class="col-12" style="font-size: 18px; font-weight: bold;">
				{{ totalExportado | numberFormat: 0 }}
			</div>
			<div class="col-12">
				{{ 'rightPanel.titulos.registrosExportados' | translate }}
			</div>
		</div>
		<div class="row" style="margin-bottom: 5px;">
			<div class="col-12">
				<h4 class="title">
					{{ 'rightPanel.titulos.ultimaExecucoes' | translate }}
				</h4>
			</div>
		</div>
		<div style="min-height: 165px;">
			<div class="row row-line" *ngFor="let item of listaTarefaHistoricoPaginados$ | async">
				<div class="col-9 ellipsis">
					{{ item.estrategiaNome }}
				</div>
				<div class="col-3" style="text-align: right;">
					{{ item.quantidade | numberFormat: 0 }}
				</div>
			</div>
			<div class="empty-state">
				<mat-icon>inbox</mat-icon>
				<p>{{'telaPadrao.semDados' | translate}}</p>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<p-paginator (onPageChange)="onPageChange($event)" [showPageLinks]="false" [first]="first" [rows]="rows"
					[totalRecords]="listaTarefaHistorico.length" />
			</div>
		</div>
	</div>
</aside>